import { render, staticRenderFns } from "./choose-inspection.vue?vue&type=template&id=bf03079e&scoped=true&"
import script from "./choose-inspection.vue?vue&type=script&lang=js&"
export * from "./choose-inspection.vue?vue&type=script&lang=js&"
import style0 from "./choose-inspection.vue?vue&type=style&index=0&id=bf03079e&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf03079e",
  null
  
)

export default component.exports